package com.essntl.features.supplier.ui.allsuppliers

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.core.utils.viewmodel.getPaginationData
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.supplier.domain.model.SupplierFilterOptions
import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.features.supplier.domain.repository.SupplierRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AllSuppliersViewModel(
    private val supplierRepository: SupplierRepository,
    private val categoryRepository: CategoryRepository,
    private val areaRepository: AreaRepository,
    private val state: MutableStateFlow<AllSuppliersState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    init {
        getAllCategoryList()
        getAllAreaList()
        getNextSuppliersPage()
    }

    fun onEvent(event: AllSuppliersEvent) {
        when (event) {
            is AllSuppliersEvent.LoadSuppliers -> getNextSuppliersPage(supplier = event.supplier)
            is AllSuppliersEvent.EditFilterOptions -> editFilterOptions(event.filterOptions)
        }
    }

    private fun getAllCategoryList() =
        getData(
            getData = { categoryRepository.getAll() },
            getState = { state.value.getAllCategory },
            setState = { newState -> state.update { it.copy(getAllCategory = newState) } },
        )

    private fun getAllAreaList() =
        getData(
            getData = { areaRepository.getAll() },
            getState = { state.value.getAllArea },
            setState = { newState -> state.update { it.copy(getAllArea = newState) } },
        )


    private fun getNextSuppliersPage(
        supplier: SupplierModel? = null,
    ) {
        if (supplier != null) {
            val newSupplier = state.value.getAllSuppliers.data.find {
                it.id == supplier.id
            }
            if (newSupplier != null) {
                // Edit supplier in the list of AllSuppliers
                updateSupplier(supplier)
            } else {
                // Add new supplier
                editFilterOptions(filterOptions = SupplierFilterOptions(), ignoreFiltering = true)
            }
        } else {
            loadMoreSuppliers()
        }
    }

    private fun updateSupplier(supplier: SupplierModel) {
        state.update {
            it.copy(
                getAllSuppliers = it.getAllSuppliers.copy(
                    data = it.getAllSuppliers.data.map { ta ->
                        if (ta.id == supplier.id) {
                            supplier
                        } else {
                            ta
                        }
                    },
                ),
            )
        }
    }

    private fun editFilterOptions(
        filterOptions: SupplierFilterOptions,
        ignoreFiltering: Boolean = false,
    ) {
        if (!ignoreFiltering && filterOptions == state.value.filterOptions) return
        state.update {
            it.copy(
                filterOptions = filterOptions,
                getAllSuppliers = PaginationState.loading(),
            )
        }

        loadMoreSuppliers(ignoreLoading = true)
    }

    private fun loadMoreSuppliers(ignoreLoading: Boolean = false) {
        if (!ignoreLoading && state.value.getAllSuppliers.isLoading) return
        getPaginationData(
            getData = {
                val nextPage = state.value.getAllSuppliers.loadedPages + 1L
                supplierRepository.getAll(
                    page = nextPage,
                    filterOptions = state.value.filterOptions,
                )
            },
            getState = { state.value.getAllSuppliers },
            setState = { state.value = state.value.copy(getAllSuppliers = it) },
            ignoreLoading = ignoreLoading,
        )
    }
}